import { render } from "./MoreDetails.vue?vue&type=template&id=25520b68&scoped=true"
import script from "./MoreDetails.vue?vue&type=script&lang=js"
export * from "./MoreDetails.vue?vue&type=script&lang=js"

import "./MoreDetails.vue?vue&type=style&index=0&id=25520b68&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\The Knight\\Desktop\\Cashoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25520b68"]])

export default __exports__